import React, { useEffect, useState } from 'react';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import EventDetailsFies from './EventDetailsFies';
import VenueFies from './VenueFies';
import SyllabusFies from './SyllabusFies';
import FeesFies from './FeesFies';
import AboutFies from './AboutFies';

import ColloboratorFies from './CollaboratorFies';
import HeaderOrg from '../Headers/HeaderOrg';
import Help from '../../Components/Help/Help';
import CreateEventTitle from '../CreateFeisEvent/Components/CreateEventTitle';
import '../GradeEventstyle.css';
import { getEventDetails } from '../../network/CreateEventFeis';

// Oireachtas creation wizard (admin-only). Cloned from the feis wizard with the
// Oireachtas deltas: NO Payment tab (the organizer connects Stripe after
// creation), so the tabs are Event Details -> Venue -> Fees -> Syllabus ->
// About -> Collaborators. Step components carry the per-tab deltas.
const OireachtasOrg = () => {
  const params = new URLSearchParams(window.location.search);
  const [eventName, setEventName] = useState("")
  const [titleLoading, setTitleLoading] = useState(true)
  const ID = params.get('id') ? params.get('id') : localStorage.getItem("ID");
  let TabNumber = localStorage.getItem('TAB');
  let pageNumber = localStorage.getItem('page');
  const tabValue = ID && TabNumber ? TabNumber : "1"
  const [value, setValue] = useState(tabValue);

  const handleChange = (event, newValue) => {
    localStorage.setItem('TAB', newValue);
    setValue(newValue);
  };

  useEffect(() => {
    getEventDetails(ID, setTitleLoading, setEventName, "oireachtas")
    return () => {
      localStorage.removeItem('previousEvent');
    }
  }, [])

  return (
    <div>
      <HeaderOrg />
      <CreateEventTitle from="oireachtas" eventName={eventName} titleLoading={titleLoading} ID={ID} />
      <div id="gradeMainTab">
        <TabContext value={value} style={{ padding: '0px' }} className="GradeOrgTab">
          <TabList onChange={handleChange} aria-label="oireachtas creation tabs" className="GradeOrgTabList">
            <Tab value='1' label="Event Details" className="GradeOrgTabb" />
            <Tab value="2" className={Number(pageNumber) + 1 >= 2 ? 'GradeOrgTabb' : 'pe-none'} label="Venue" />
            <Tab value="3" className={Number(pageNumber) + 1 >= 3 ? 'GradeOrgTabb' : 'pe-none'} label="Fees" style={{ minWidth: 0 }} />
            <Tab value="4" className={Number(pageNumber) + 1 >= 4 ? 'GradeOrgTabb' : 'pe-none'} label="Syllabus" style={{ minWidth: 0 }} />
            <Tab value="5" className={Number(pageNumber) + 1 >= 5 ? 'GradeOrgTabb' : 'pe-none'} label="About" style={{ minWidth: 0 }} />
            <Tab value="6" className={Number(pageNumber) + 1 >= 6 ? 'GradeOrgTabb' : 'pe-none'} label="Collaborators" />
          </TabList>
          <div className="hr-org-title" style={{ marginTop: '-2px' }} />
          <div maxWidth="md" className="create-feis-content">
            <TabPanel value="1" id="TabSize" className="Tabpanel" >
              <EventDetailsFies setValue={setValue} setEventName={setEventName} type="oireachtas" />
            </TabPanel>
            <TabPanel value="2" id="TabSize">
              <VenueFies setValue={setValue} type="oireachtas" />
            </TabPanel>
            <TabPanel value="3" id="TabSize" style={{ minWidth: 0 }} >
              <FeesFies setValue={setValue} value={value} type="oireachtas" />
            </TabPanel>
            <TabPanel value="4" id="TabSize" style={{ minWidth: 0 }} >
              <SyllabusFies setValue={setValue} />
            </TabPanel>
            <TabPanel value="5" id="TabSize" style={{ minWidth: 0 }} >
              <AboutFies setValue={setValue} type="oireachtas" />
            </TabPanel>
            <TabPanel value="6" id="TabSize" style={{ minWidth: 0 }} >
              <ColloboratorFies setValue={setValue} />
            </TabPanel>
          </div>
        </TabContext>
        <Help />
      </div>
    </div>
  );
};

export default OireachtasOrg;
